<template>
  <aside
    class="floating-contact-tools"
    :style="{ bottom }"
    aria-label="快捷联系入口"
  >
    <div :class="['floating-contact-rail', { 'floating-contact-rail--qq': showQq }]">
      <button
        class="floating-contact-tool feedback-tool"
        type="button"
        data-track-text="意见反馈"
        aria-label="意见反馈"
        @click="openFeedback"
      >
        <img
          src="@/assets/img/yj.png"
          alt=""
          title="欢迎您提建议"
        >
      </button>

      <el-popover
        v-if="showQq"
        placement="left-start"
        title="客服在线时间"
        width="120"
        trigger="hover"
      >
        <p class="service-time">法定工作日<br>早 9:00 至晚 5:00</p>
        <a
          slot="reference"
          class="floating-contact-tool contact-popover-reference qq-tool"
          :href="qqUrl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="QQ 在线咨询"
        >
          <img src="@/assets/img/qq.png" alt="QQ 在线咨询">
        </a>
      </el-popover>

      <el-popover
        placement="left-start"
        title=""
        width="200"
        trigger="hover"
      >
        <img class="wechat-qr-code" src="@/assets/img/公众号.jpg" alt="微信公众号二维码">
        <span slot="reference" class="contact-popover-reference">
          <button
            class="floating-contact-tool wechat-tool"
            type="button"
            aria-label="关注微信公众号"
          >
            <span>关注微信</span>
            <span>公众号</span>
          </button>
        </span>
      </el-popover>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'FloatingContactTools',
  props: {
    bottom: {
      type: String,
      default: '166px'
    },
    showQq: {
      type: Boolean,
      default: false
    },
    qqUrl: {
      type: String,
      default: 'http://wpa.qq.com/msgrd?v=3&uin=1077258421&site=qq&menu=yes'
    }
  },
  methods: {
    openFeedback () {
      const availableWidth = Math.max(0, window.innerWidth - 32)
      const availableHeight = Math.max(0, window.innerHeight - 32)
      const width = Math.min(948, availableWidth || 948)
      const height = Math.min(625, availableHeight || 625)
      this.$authPopup.open('/recommendations', {
        area: [`${width}px`, `${height}px`],
        skin: 'login-demo-class home-auth-layer feedback-layer'
      })
      this.$emit('feedback')
    }
  }
}
</script>

<style scoped>
.floating-contact-tools {
  position: fixed;
  right: 0;
  z-index: 100;
  width: 60px;
  overflow: visible;
  box-sizing: border-box;
}

.floating-contact-rail {
  width: 60px;
  height: 120px;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 10px 0 0 10px;
  background: #fff;
  box-shadow: inset 0 0 0 1px var(--border), 0 8px 24px rgba(0, 0, 0, .12);
}

.floating-contact-rail--qq {
  height: 180px;
}

.floating-contact-tool {
  width: 60px;
  height: 60px;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  color: #333;
  border: 0;
  border-radius: 0;
  background: #fff;
  font: 14px/20px "Microsoft YaHei", sans-serif;
  cursor: pointer;
}

.floating-contact-tool:hover,
.floating-contact-tool:focus-visible {
  background: #f3f7fb;
}

.feedback-tool {
  border-bottom: 1px solid rgba(139, 143, 148, .25);
}

.feedback-tool img {
  width: 26px;
  height: 28px;
  display: block;
}

.contact-popover-reference {
  width: 60px;
  height: 60px;
  display: block;
  line-height: 0;
}

.wechat-tool {
  flex-direction: column;
}

.qq-tool {
  display: flex;
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid rgba(139, 143, 148, .25);
}

.qq-tool img {
  width: 28px;
  height: 28px;
  display: block;
}

.wechat-qr-code {
  width: 200px;
  height: auto;
  display: block;
}

.service-time {
  margin: 0;
  color: #4b5563;
  font: 13px/22px "Microsoft YaHei", sans-serif;
}

@media (max-width: 900px) {
  .floating-contact-tools {
    right: 12px;
  }
}

@media (max-width: 768px) {
  .floating-contact-tools {
    display: none !important;
  }
}
</style>
